const builderBlockSelector = "[data-builder-block-path]";
const builderFormBlockSelector = '[data-builder-block-type="form"]';
const formControlSelector = "button, input, select, textarea";

/**
 * Disabled form controls do not consistently dispatch click events. Resolve
 * their authored block from pointer-down so Field and Submit remain directly
 * selectable; runtime-only controls naturally fall back to their Form.
 */
export function builderStudioFormControlSelectionTarget(
  target: Element,
): Element | null {
  const formBlock = target.closest(builderFormBlockSelector);
  const control = target.closest(formControlSelector);

  if (
    !formBlock
    || !control
    || control.closest(builderFormBlockSelector) !== formBlock
  ) {
    return null;
  }

  return target.closest(builderBlockSelector) ?? formBlock;
}
